import { createAsyncThunk } from '@reduxjs/toolkit'
import { reviewAdminSuggestion } from 'shared/api/admin'

export const reviewSuggestion = createAsyncThunk(
    'admin/reviewSuggestion',
    async ({ decision, direction }, { getState }) => {
        const state = getState().admin
        const result = await reviewAdminSuggestion(state.currentSuggestId, {
            decision,
            text: state.currentText,
            img: state.currentImage,
            speak: state.currentSpeak,
            collectionIds: state.currentCollection,
        })
        return { result, direction }
    }
)
